import Node from './node';

export default class ObjectRef extends Node {
  clone() {
    return new ObjectRef(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
